(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(84865);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _components_decorators_MccDecorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78202);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var _components_search_SearchResults__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25915);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12918);
/* harmony import */ var _components_userContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58282);
/* harmony import */ var _components_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9229);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);









var __N_SSP = true;
function Home(_ref) {
  var numFound = _ref.numFound,
      results = _ref.results,
      rows = _ref.rows,
      facets = _ref.facets,
      participants = _ref.participants,
      errorCode = _ref.errorCode;

  if (errorCode && errorCode > 404) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_4__, {
      statusCode: errorCode,
      title: (0,_components_utils__WEBPACK_IMPORTED_MODULE_6__/* .generateServerErrorMessage */ .bO)(errorCode)
    });
  }

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var user = (0,_components_userContext__WEBPACK_IMPORTED_MODULE_5__/* .useUserContext */ .S)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_decorators_MccDecorator__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
    title: _components_decorators_MccDecorator__WEBPACK_IMPORTED_MODULE_0__/* .siteTitle */ .y7,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "row",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: "col-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h1", {
          children: "Dashboard"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("p", {
          style: {
            fontSize: 'large'
          },
          children: ["Welcome to MCC Manager, a tool for adding, editing, deleting, and publishing MCC products. Displaying active products assigned to ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("strong", {
            children: participants
          }), "."]
        })]
      }), user && !user.isMccIcpsrArchiveManager && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "col-2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__, {
          href: "/products/create",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
            className: "btn btn-primary",
            children: "Create Product"
          })
        })
      })]
    }), numFound === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
      children: "There are currently no active products assigned to you."
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_search_SearchResults__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      results: results,
      facets: facets,
      numFound: numFound,
      sourcePath: '/',
      rows: rows,
      totalPages: Math.ceil(numFound / rows)
    })]
  });
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [714,885,726,976,77,416,246,264,929,774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);